import { AuthService } from "../utils/auth";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1";

export interface ShotReaction {
  id: string;
  emoji: string;
  userId: string;
  firstName: string | null;
  createdAt: string;
}

export interface Shot {
  id: string;
  title: string;
  description?: string | null;
  videoKey: string;
  posterKey: string | null;
  videoUrl: string;
  posterUrl: string | null;
  likes: number;
  displayOrder: number;
  isActive: boolean;
  reactions?: ShotReaction[];
  reactionsCount?: number;
  createdAt: string;
  updatedAt: string;
}

export interface ShotsPagination {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  hasNext: boolean;
  hasPrev: boolean;
}

export interface PaginatedShots {
  shots: Shot[];
  pagination: ShotsPagination;
}

export async function getShots(page = 1, limit = 10): Promise<PaginatedShots> {
  const res = await fetch(`${API_BASE_URL}/shots?page=${page}&limit=${limit}`);
  if (!res.ok)
    return {
      shots: [],
      pagination: {
        page: 1,
        limit,
        total: 0,
        totalPages: 0,
        hasNext: false,
        hasPrev: false,
      },
    };
  const body = await res.json();
  return {
    shots: body?.data?.shots ?? [],
    pagination: body?.data?.pagination ?? {
      page: 1,
      limit,
      total: 0,
      totalPages: 0,
      hasNext: false,
      hasPrev: false,
    },
  };
}

export async function likeShot(id: string): Promise<number> {
  const res = await fetch(`${API_BASE_URL}/shots/${id}/like`, {
    method: "POST",
  });
  if (!res.ok) throw new Error("Like failed");
  const body = await res.json();
  return body?.data?.likes ?? 0;
}

export async function reactToShot(
  id: string,
  emoji = "❤️",
): Promise<{ reacted: boolean; emoji: string }> {
  const token = AuthService.getAccessToken();
  if (!token) throw new Error("Authentication required");

  const res = await fetch(`${API_BASE_URL}/shots/${id}/react`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ emoji }),
  });
  if (!res.ok) throw new Error("React failed");
  const body = await res.json();
  return body?.data ?? { reacted: false, emoji };
}
